var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#6B7DE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 7.33337L20.1953 8.1953C20.4557 8.45565 20.4557 8.87776 20.1953 9.13811L19.3334 10M16.6667 8.66671H20M10 14.6667L11.4667 15.7667C12.1778 16.3 13.1556 16.3 13.8667 15.7667L15.3334 14.6667M9.33337 20.6667H16C17.1046 20.6667 18 19.7713 18 18.6667V13.3334C18 12.2288 17.1046 11.3334 16 11.3334H9.33337C8.2288 11.3334 7.33337 12.2288 7.33337 13.3334V18.6667C7.33337 19.7713 8.2288 20.6667 9.33337 20.6667Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCampaign);
export default __webpack_public_path__ + "static/media/active_campaign.a4cebda7143b9892ea3011ebfb317562.svg";
export { ForwardRef as ReactComponent };